export const PAID_MEDIA_NETWORKS = [
    { name: 'shopify', label: 'Shopify', icon: '/assets/shopify.svg' },
    { name: 'ga', label: 'Google Analytics', icon: '/assets/analytics.svg' },
    { name: 'meta', label: 'Meta', icon: '/assets/meta.svg' },
    { name: 'adword', label: 'Google Ads', icon: '/assets/adwords.svg' },
    { name: 'bing', label: 'Bing Ads', icon: '/assets/bing.svg' },
    { name: 'criteo', label: 'Criteo', icon: '/assets/criteo.svg' },
    { name: 'klaviyo', label: 'Klaviyo', icon: '/assets/klaviyo.svg' },
];
export const AFFILIATE_NETWORKS = [
    { name: 'avantlink', label: 'Avantlink', icon: '/assets/avantlink.png' },
    { name: 'awin', label: 'Awin', icon: '/assets/awin.png' },
    { name: 'cj', label: 'CJ', icon: '/assets/cj.png' },
    { name: 'commission_factory', label: 'Commission Factory', icon: '/assets/commission-factory.svg' },
    { name: 'costingtons', label: 'Costingtons', icon: '/assets/costingtons.svg' },
    { name: 'impact', label: 'Impact', icon: '/assets/impact.svg' },
    { name: 'levanta', label: 'Levanta', icon: '/assets/levanta.png' },
    { name: 'partnerize', label: 'Partnerize', icon: '/assets/partnerize.svg' },
    { name: 'partnerstack', label: 'Partnerstack', icon: '/assets/partnerstack.svg' },
    { name: 'pepperjam', label: 'Pepperjam', icon: '/assets/aff_peeperjam.png' },
    { name: 'rakuten', label: 'Rakuten', icon: '/assets/rakuten.png' },
    { name: 'refersion', label: 'Refersion', icon: '/assets/refersion.png' },
    { name: 'shareasale', label: 'ShareASale', icon: '/assets/shareasale.png' }
    // { name: 'wayward', label: 'Wayward', icon: '/assets/others.svg' },
];
// Not a connectable network — only used as a source/filter value (e.g. sync logs).
export const OTHER_NETWORKS = [
    { name: 'performance_tracker', label: 'Performance Tracker', icon: '/assets/others.svg' },
    { name: 'channels_revenue', label: 'Channels Revenue', icon: '/assets/channel_rev.svg' },
];
export const ALL_NETWORKS = [...PAID_MEDIA_NETWORKS, ...AFFILIATE_NETWORKS, ...OTHER_NETWORKS];
export const NETWORK_LABEL_MAP = ALL_NETWORKS.reduce((acc, network) => {
    acc[network.name] = network.label;
    if (network.name === 'rakuten') {
        acc['rakuten (linkshare)'] = network.label;
    }
    if (network.name === 'shareasale') {
        acc['share a sale'] = network.label;
    }
    return acc;
}, {});
/**
 * Combined map of network metadata (icon and label)
 */
export const NETWORK_METADATA_MAP = ALL_NETWORKS.reduce((acc, network) => {
    acc[network.name] = { icon: network.icon, name: network.label };
    if (network.name === 'commission_factory') {
        acc['commision_factory'] = { icon: network.icon, name: network.label };
    }
    return acc;
}, {});
export const NETWORK_ICON_MAP = ALL_NETWORKS.reduce((acc, network) => {
    acc[network.name] = network.icon;
    if (network.name === 'commission_factory') {
        acc['commision_factory'] = network.icon;
    }
    if (network.name === 'rakuten') {
        acc['rakuten (linkshare)'] = network.icon;
    }
    if (network.name === 'shareasale') {
        acc['share a sale'] = network.icon;
    }
    return acc;
}, {});
